<template>
<div class="chapter">
<div class="inner_page">
<p class="p2"><span class="sz"> </span></p>
<p class="p1"><span class="sz">This book was not written to destroy myths but so far as possible to cut through them to the reality underneath. I have not written from a present-minded or problem-oriented viewpoint, but to put things in broad perspective. The history of Texas, in perspective, lies at the core of the history of fully one-quarter of the United States. It can neither be repudiated nor ignored.</span></p>
<p class="p1"><span class="sz">As Walter Prescott Webb wrote, “The historian whose work is to stand the test must deal with facts as if they were remote, with people as if they were no longer living, with conditions as they are or were and not as they should have been.” I am a Texan, but I have deliberately tried to write about Texans in this book as if they were Frenchmen or Chinese.</span></p>
<p class="p1"><span class="sz">For those Americans who may be appalled at the thought that so much American destiny was wrought by the flash of flintlocks and the nation in its present form built over the bones of countless Amerinds, Mexicans, and Confederates, I might add that Texans, first and last, have always been Americans, too.</span></p>
<p class="p2"><span class="sz"> </span></p>
<p class="p4"><span class="sz">T. R. F.</span></p>
<p class="p2"><span class="sz"> </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section5.vue?7178cefc